import { MRT_Localization_ES } from "material-react-table/locales/es";

export const localization = {
  header: {
    actions: "",
  },
  cells: {
    sx: {
      whiteSpace: 'normal',
      wordBreak: 'break-word',
    },
  },
  pagination: {
    labelDisplayedRows: "{from}-{to} de {count}",
    labelRowsSelect: "filas",
    firstTooltip: "Primera página",
    previousTooltip: "Página anterior",
    nextTooltip: "Página siguiente",
    lastTooltip: "Última página",
  },
  toolbar: {
    searchPlaceholder: "Buscar...",
    exportTitle: "Exportar",
    exportName: "Exportar a CSV",
    nRowsSelected: `{0} fila(s) seleccionada(s)`,
  },
  rowStyle: {
    fontFamily: "Roboto, sans-serif !important",
  },
  headerStyle: {
    color: "rgba(0, 0, 0, 0.54)",
    fontSize: "0.65rem",
    lineHeight: "1.3125rem",
    fontFamily: "Roboto, sans-serif !important",
  },
  pagination: {
    labelDisplayedRows: "{from}-{to} de {count}",
    labelRowsSelect: "filas",
    firstTooltip: "Primera página",
    previousTooltip: "Página anterior",
    nextTooltip: "Página siguiente",
    lastTooltip: "Última página",
  },
  toolbar: {
    searchPlaceholder: "Buscar...",
    exportTitle: "Exportar",
    exportName: "Exportar a CSV",
    nRowsSelected: `{0} fila(s) seleccionada(s)`,
  },
};

export const tableConfig = {
  enableGlobalFilter: false,
  enableColumnActions: false,
  enableHiding: false,
  positionActionsColumn: "last",

  enablePersistence: false,
  stateSaving: false,
  enableColumnDragging: false,
  enableColumnOrdering: false,
  enablePersistentColumnOrder: false,
  autoResetAll: true,

  localization: MRT_Localization_ES,
  muiTableHeadCellProps: {
    sx: {
      color: "rgba(0, 0, 0, 0.54)",
      fontSize: "0.65rem",
      lineHeight: "1.3125rem",
      fontFamily: "Roboto, sans-serif !important",
      justifyContent: "end",
    },
  },
  muiTableBodyCellProps: {
    sx: {
      whiteSpace: "normal",
      overflowWrap: "break-word",
    },
  },
  muiTableBodyRowProps: {
    sx: {
      fontFamily: "Roboto, sans-serif !important"
    }
  },

  defaultColumn: {
    grow: true,
    muiFilterTextFieldProps: {
      placeholder: '',
    },
  },
  muiFilterDatePickerProps: {
    slotProps: {
      textField: {
        placeholder: '',
      },
    },
  },
  muiFilterDateTimePickerProps: {
    slotProps: {
      textField: {
        placeholder: '',
      },
    },
  },

  initialState: {
    density: 'compact',
    showColumnFilters: true,
    columnOrder: [],
  }
};